import type { AccountInfo } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';

export function useMsalAccount(): AccountInfo | null {
	const { accounts } = useMsal();
	const account = useAccount(accounts?.[0] || null);
	return account;
}
